"use client";

import React from "react";
import PropTypes from "prop-types";
import LiteYTEmbed from "react-lite-youtube-embed";

const createYTParams = (start, end) => {
  const params = new URLSearchParams();
  if (start) {
    params.set("start", start);
  }
  if (end) {
    params.set("end", end);
  }
  return params.toString();
};

// Provide an easy way to add YouTube videos to Markdown pages:
const MDYTVideo = ({src, start, end, ratio = "16by9", caption}) => {
  const params = createYTParams(start, end);
  const [aspectWidth, aspectHeight] = ratio.split("by");
  let figCaption = null;
  if (caption) {
    const captionLines = caption.split("\\n").map((line, index) => (
      <React.Fragment key={`figcaption.line#${index}`}>
        {line}
        <br></br>
      </React.Fragment>
    ));
    figCaption = <figcaption>{captionLines}</figcaption>;
  }

  return (
    <figure className={`image is-${ratio} is-video`}>
      <div className="has-ratio">
        <LiteYTEmbed adNetwork={false} aspectHeight={aspectHeight}
                     aspectWidth={aspectWidth} id={src}
                     muted={false} params={params}/>
      </div>
      {figCaption && figCaption}
    </figure>
  );
};

MDYTVideo.propTypes = {
  src: PropTypes.string.isRequired,
  start: PropTypes.string,
  end: PropTypes.string,
  ratio: PropTypes.string,
  caption: PropTypes.string,
};

export default MDYTVideo;
